export default "__VITE_ASSET__CGhL9LDk__"